import script from "./Alpha.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alpha.vue?vue&type=script&lang=ts&setup=true"

import "./Alpha.vue?vue&type=style&index=0&id=84628bc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84628bc8"]])

export default __exports__